export default "__VITE_ASSET__eJiLw5y5__"